import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const linkedin: Platform = {
  id: 'linkedin',
  name: 'LinkedIn',
  iconIndex: PlatformRegistry.linkedin.index,
  color: PlatformRegistry.linkedin.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://www.linkedin.com/sharing/share-offsite/', {
      url: content.url,
    });
  },
};

